/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_TICKET_ORDERS, GET_TICKET_ORDERS } from 'src/actions/ticketOrderActions';

const initialState = {
  items: [],
  total: 0,
  isFetching: false,
  message: ''
};

const ticketOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_TICKET_ORDERS: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_TICKET_ORDERS: {
      const { ticketOrders, total, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = ticketOrders;
        draft.total = total;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default ticketOrderReducer;
